import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// COPY FEATURE (commented): these imports were only used by the copy functionality
// import React, { useEffect, useMemo, useState } from "react";
// import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Badge } from "reactstrap";
// import { customAlert } from "../../../CustomAlert/ConfirmDialog";
// import { C_Select } from "../../../CustomValidateForm";
// import { loginUserDetails } from "../../../components/Common/CommonFunction";
import CashBookHead from "./CashBookHead";
import {
  deleteCashBookHeadID,
  deleteCashBookHeadIDSuccess,
  editCashBookHeadID,
  getCashBookHeadList,
  getCashBookHeadListSuccess,
  saveCashBookHeadSuccess,
  updateCashBookHeadIDSuccess,
} from "../../../store/Administrator/CashBookHeadRedux/action";
import { commonPageFieldList, commonPageFieldListSuccess } from "../../../store/actions";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";
import * as pageId from "../../../routes/allPageID";
import * as url from "../../../routes/route_url";
import * as mode from "../../../routes/PageMode";
import { PageLoadingSpinner } from "../../../components/Common/CommonButton";

/* ------------------------------------------------------------------ */
/* Copy popup  (COMMENTED OUT)                                         */
/* ------------------------------------------------------------------ */
// const partyCardStyle = {
//   flex: 1,
//   minWidth: 220,
//   borderRadius: 10,
//   padding: "14px 16px",
//   border: "1px solid #e3e6ec",
//   background: "#f8f9fb",
// };
//
// const labelStyle = {
//   fontSize: 11,
//   fontWeight: 600,
//   letterSpacing: ".6px",
//   textTransform: "uppercase",
//   color: "#74788d",
//   marginBottom: 6,
// };
//
// const CopyHeadsModal = ({ isOpen, toggle, sourceParty, selectedRows, partyOptions, onConfirm }) => {
//   const [targetParty, setTargetParty] = useState(null);
//   const [error, setError] = useState("");
//
//   // reset every time the popup opens
//   useEffect(() => {
//     if (isOpen) {
//       setTargetParty(null);
//       setError("");
//     }
//   }, [isOpen]);
//
//   // the party we copy FROM must not appear in the "copy to" list
//   const targetOptions = useMemo(
//     () => partyOptions.filter((p) => p.value !== sourceParty?.value),
//     [partyOptions, sourceParty]
//   );
//
//   const confirmHandler = () => {
//     if (!targetParty) {
//       setError("Please select the party you want to copy to");
//       return;
//     }
//     onConfirm({ targetParty, selectedRows });
//   };
//
//   return (
//     <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
//       <ModalHeader toggle={toggle}>
//         <span className="bx bx-copy-alt me-2" />
//         Copy Cash Book Heads
//       </ModalHeader>
//
//       <ModalBody>
//         {/* FROM  ->  TO */}
//         <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
//           <div style={partyCardStyle}>
//             <div style={labelStyle}>Copying from</div>
//             <div style={{ fontSize: 16, fontWeight: 600, color: "#2a3042" }}>
//               {sourceParty?.label || "-"}
//             </div>
//           </div>
//
//           <div
//             style={{
//               width: 42,
//               height: 42,
//               borderRadius: "50%",
//               background: "#556ee6",
//               color: "#fff",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//               margin: "0 auto",
//             }}
//           >
//             <span className="bx bx-right-arrow-alt" style={{ fontSize: 24 }} />
//           </div>
//
//           <div style={{ ...partyCardStyle, background: "#fff", borderColor: error ? "#f46a6a" : "#556ee6" }}>
//             <div style={labelStyle}>Copy to</div>
//             <C_Select
//               name="CopyToParty"
//               classNamePrefix="select2-Customer"
//               value={targetParty}
//               options={targetOptions}
//               placeholder="Select party..."
//               onChange={(e) => {
//                 setTargetParty(e);
//                 setError("");
//               }}
//               styles={{ menu: (provided) => ({ ...provided, zIndex: 3 }) }}
//             />
//             {error && <div style={{ color: "#f46a6a", fontSize: 12, marginTop: 6 }}>{error}</div>}
//           </div>
//         </div>
//
//         {/* selected heads */}
//         <div style={{ marginTop: 22 }}>
//           <div style={labelStyle}>Selected heads ({selectedRows.length})</div>
//           <div
//             style={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: 8,
//               maxHeight: 140,
//               overflowY: "auto",
//               padding: 10,
//               border: "1px dashed #ced4da",
//               borderRadius: 8,
//             }}
//           >
//             {selectedRows.map((r) => (
//               <Badge key={r.id} color="primary" className="font-size-13 py-1 px-2" pill>
//                 {r.HeadName}
//               </Badge>
//             ))}
//           </div>
//         </div>
//       </ModalBody>
//
//       <ModalFooter>
//         <Button color="light" onClick={toggle}>
//           Cancel
//         </Button>
//         <Button color="primary" onClick={confirmHandler}>
//           <span className="bx bx-copy me-1" />
//           Copy {selectedRows.length} head{selectedRows.length > 1 ? "s" : ""}
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

/* ------------------------------------------------------------------ */
/* List page                                                           */
/* ------------------------------------------------------------------ */
const CashBookHeadList = () => {
  const dispatch = useDispatch();
  // const isCopyAllowed = loginUserDetails()?.IsAdminDivision == "1";   // COPY FEATURE (commented)
  const reducers = useSelector((state) => ({
    listBtnLoading: state.CashBookHeadReducer.listBtnLoading,
    goBtnLoading: state.CashBookHeadReducer.goBtnLoading,
    tableList: state.CashBookHeadReducer.CashBookHeadListData,
    editData: state.CashBookHeadReducer.editData,
    updateMsg: state.CashBookHeadReducer.updateMessage,
    deleteMsg: state.CashBookHeadReducer.deleteMessage,
    userAccess: state.Login.RoleAccessUpdateData,
    postMsg: state.CashBookHeadReducer.postMsg,
    pageField: state.CommonPageFieldReducer.pageFieldList,
  }));

  const { pageField, goBtnLoading } = reducers;

  // COPY FEATURE (commented): party dropdown data + options used only by the copy popup
  // const {
  //   commonPartyDropSelect,
  //   commonPartyDropdownOption = [],
  //   partyDropdownLoading,
  //   isShowOnlySAPParty,
  // } = useSelector((state) => state.CommonPartyDropdownReducer);
  //
  // // same generation logic as PartyDropdownOptions in ChangeCommonParty
  // const partyOptions = useMemo(
  //   () =>
  //     commonPartyDropdownOption
  //       .map((data) => ({
  //         value: data.id,
  //         label: data.Name,
  //         SAPPartyCode: data.SAPPartyCode,
  //         Latitude: data.Latitude,
  //         Longitude: data.Longitude,
  //         MobileNo: data.MobileNo,
  //         Address: data.Address,
  //         PartyType: data.PartyType,
  //         PartyTypeID: data.PartyTypeID,
  //         IsFranchise: data.IsFranchise,
  //       }))
  //       .filter((index) => !isShowOnlySAPParty || index.SAPPartyCode !== null),
  //   [commonPartyDropdownOption, isShowOnlySAPParty]
  // );
  //
  // const [copyModalOpen, setCopyModalOpen] = useState(false);
  // const [copyRows, setCopyRows] = useState([]);

  const action = {
    getList: getCashBookHeadList,
    editId: editCashBookHeadID,
    deleteId: deleteCashBookHeadID,
    postSucc: saveCashBookHeadSuccess,
    updateSucc: updateCashBookHeadIDSuccess,
    deleteSucc: deleteCashBookHeadIDSuccess,
  };

  // COPY FEATURE (commented): Copy button (bottom draggable) -> validate, then open popup
  // const CopyHandler = (list = []) => {
  //   if (!isCopyAllowed) return;
  //   const selectedRows = list.filter((i) => i.selectCheck && !i.forceSelectDissabled);
  //
  //   if (selectedRows.length === 0) {
  //     customAlert({ Type: 4, Message: "Please select at least one record to copy" });
  //     return;
  //   }
  //   if (!(commonPartyDropSelect?.value > 0)) {
  //     customAlert({ Type: 3, Message: "Please select a party first" });
  //     return;
  //   }
  //   setCopyRows(selectedRows);
  //   setCopyModalOpen(true);
  // };
  //
  // // "Copy" inside the popup
  // const copyConfirmHandler = ({ targetParty, selectedRows }) => {
  //   const payload = {
  //     FromParty: commonPartyDropSelect.value,
  //     ToParty: targetParty.value,
  //     CashBookHeadIDs: selectedRows.map((r) => r.id),
  //   };
  //   // TODO: dispatch / call your copy API with `payload`
  //   console.log("Copy payload:", payload);
  //   setCopyModalOpen(false);
  // };

  useEffect(() => {
    dispatch(commonPageFieldListSuccess(null));
    dispatch(commonPageFieldList(pageId.CASH_BOOK_HEAD_LIST));
    dispatch(getCashBookHeadList("list"));
    return () => {
      dispatch(getCashBookHeadListSuccess([]));
      dispatch(commonPageFieldListSuccess(null));
    };
  }, []);
  return (
    <React.Fragment>
      <PageLoadingSpinner isLoading={goBtnLoading || !pageField} />
      <div className="page-content">
        {pageField && (
          <CommonPurchaseList
            action={action}
            reducers={reducers}
            showBreadcrumb={false}
            masterPath={url.CashBookHead}
            newBtnPath={url.CashBookHead}
            pageMode={mode.defaultList}
            goButnFunc={() => dispatch(getCashBookHeadList("list"))}
            MasterModal={CashBookHead}
            ButtonMsgLable={"CashBook Head"}
            deleteName={"HeadName"}
            /* COPY FEATURE (commented)
            selectCheckParams={{
              isShow: isCopyAllowed,
              forceHideSelect: !isCopyAllowed,   // hides the Copy column and the bottom button completely
              selectHeaderLabel: "Copy",
              selectSaveBtnLabel: "Copy",
              selectSaveBtnHandler: CopyHandler,
              selectSaveBtnLoading: false,
            }}
            */
          />
        )}
      </div>

      {/* COPY FEATURE (commented): copy popup
      {isCopyAllowed && (
        <CopyHeadsModal
          isOpen={copyModalOpen}
          toggle={() => setCopyModalOpen(false)}
          sourceParty={commonPartyDropSelect}
          selectedRows={copyRows}
          partyOptions={partyOptions}
          partyLoading={partyDropdownLoading}
          onConfirm={copyConfirmHandler}
        />
      )}
      */}
    </React.Fragment>
  );
};

export default CashBookHeadList;